import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterrequestcustomerFactorService {

  constructor(private http: HttpClient) { }

  GetFactor(Token: String, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/GetFactor?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Add(Token: String, src: String, letter_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/Add?token=" + Token
      + "&src=" + src
      + "&letter_id=" + letter_id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Delete(Token: String, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/Delete?token=" + Token + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  uploadFile(body, Token: String) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/LetterrequestcustomerFactor/Upload?token=" + Token, body).pipe(
      map(data => {

        return data
      })
    )
  }


}
